import { render, staticRenderFns } from "./AppContactSupportView.vue?vue&type=template&id=76ff527c"
import script from "./AppContactSupportView.vue?vue&type=script&lang=ts"
export * from "./AppContactSupportView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports